// Blobをブラウザのダウンロードとして保存する。
// 生成方法（CSV文字列 / ZIP / xlsx）に依らない共通処理をここに集約する。
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
